








import {Component, Prop, Vue} from "vue-property-decorator";
import {formatIntervalDate} from "../../../../common/dateTimeHelper";
import {Element} from "../../../../api/models/Element";


@Component({
    name: 'EventInfoTitle'
})
export default class EventInfo extends Vue {
    /**
     * Data helper for data manipulation, comes from vuex store by date
     */
    @Prop({required: true}) eventId: string;
    @Prop({ default: 1 }) lineClamp: number;
    @Prop({ default: false}) showSubtitle: boolean;

    get eventFormattedDate() {

        const beginAt = this.selectedEvent?.beginAt;
        const endAt = this.selectedEvent?.endAt;

        if(beginAt && endAt) {
            return formatIntervalDate(beginAt.toObject(), endAt.toObject(), this.lang, true);
        }

        return "";
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get selectedEvent(): Element | undefined {
        return this.$store.getters['events/selectedEvent'];
    }

    get event() {
        return this.$store.getters["events/sortedListByEndDateDesc"]?.find((event: Element) => event.id === this.eventId)
    }

    get title() {
        return this.event?.title || '';
    }

    get subtitle() {
        return this.event?.subtitle || '';
    }
}
